import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Link } from 'react-router-dom'
import Path from 'path-parser'
import FahrerList from './fahrer/FahrerList'
import bild from '../img/fahrerlistebeispiel.png'
import { submitFahrerBatch } from '../actions'
import ReactFileReader from 'react-file-reader'
import Modal from 'react-modal'

const re = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/

const modalStyles = {
	content: {
		top					: '50%',
		left 				: '50%',
		right 			: 'auto',
		bottom			: 'auto',
		marginRight : '-50%',
		transform 	: 'translate(-50%, -50%)'
	}
}

Modal.setAppElement('#root');

class Dashboard extends Component {

	constructor(props) {
		super(props);
		this.state = {
			showUploadButtons: this.props.auth && true,
			modalIsOpen: false
		}
		this.csvHilfe = this.csvHilfe.bind(this);
		this.openModal = this.openModal.bind(this);
		this.afterOpenModal = this.afterOpenModal.bind(this);
		this.closeModal = this.closeModal.bind(this);
	}

	openModal() {
		this.setState({modalIsOpen: true});
	}

	afterOpenModal() {
    // references are now sync'd and can be accessed.
    this.subtitle.style.color = '#f00';
  }

  closeModal() {
    this.setState({modalIsOpen: false});
  }

	listEmails = async function (l) {
		for (const m in l) {
			const myMailAdr = await m.strip();
			console.log(myMailAdr);
		}
	}

	csvHilfe = function() {
		this.openModal();
	}

	handleFiles = files => {
		//console.log(files);

		const that = this;

		const reader = new FileReader();
		reader.onload = function (e) {
			//console.log(reader.result);
			const s = reader.result;
			const a = s.split(/\r\n|\n/).filter(m => m !== '').map(m => m.trim());
			const a_final = [];


			for (var i=0; i<a.length; i++) {
			//for (const m of a) {
				const m = a[i];
				console.log(m, m.length);
				if (re.test(m) === true) {
					a_final.push(m)
				}
				// So, und jetz hier einen Filter einbauen, Emails validieren
				// und dann die Liste ans Backend schicken. ;-)
			}
			console.log("a_final:", a_final);
			that.props.actions.submitFahrerBatch(a);
		}

		reader.readAsText(files[0]);
	}

	showDetailPath() {
		const p = new Path(this.props.location.pathname);
		console.log(p.tokens);
		console.log("dashboard refs:", this.refs);
		//console.log(p.tokens.filter((t) => t.type === 'fragment').map((t) => t.match));
	}

	computeFahrerCreditsUebrig() {
		const anzahlFahrer = this.props.fahrer.length;
		const anzahlCredits = this.props.auth.credits + this.props.auth.creditsFn;
		const uebrig = anzahlCredits - anzahlFahrer;
		return uebrig;
	}

	componentDidUpdate() {
		const fcue = this.computeFahrerCreditsUebrig();
		if ((fcue > 0) !== this.state.showUploadButtons) {
			this.setState({showUploadButtons: fcue > 0});
		}
	}

	render () {

		return (
			<div>
				<Modal
					isOpen={this.state.modalIsOpen}
					onAfterOpen={this.afterOpenModal}
					onRequestClose={this.closeModal}
					style={modalStyles}
					contentLabel="Example Modal"
				>

					<h3 ref={subtitle => this.subtitle = subtitle}>CSV Hilfe</h3>

					<div style={{width: '300px'}}>Um mehrere Email-Adressen gleichzeitig anzulegen, kann man eine <b>CSV-Datei</b> verwenden.
					Die Datei muss die Endung '.csv' haben und besteht einfach aus einer Liste von Email-Adressen, die mit Return getrennt sind.
					Man kann z.B. eine Liste wie die hier abgebildete aus Excel exportieren: <b>Speichern unter</b> und dann <b>csv</b> als Format wählen.</div>
				<div style={{marginTop: '10px'}}>
						<img className="" src={bild} alt="bild"/>
					</div>
					<button className="btn right" onClick={this.closeModal}>schließen</button>
				</Modal>

				{this.props.auth && <FahrerList />}
				{this.state.showUploadButtons && <div className="fixed-action-btn">
					<Link to="/fahrer/new" style={{float:'left'}}>
						<button className="btn btn-default">
						Fahrer hinzufügen
						</button>
					</Link>
					<div style={{float:'left', marginLeft:'10px'}}>
					<ReactFileReader handleFiles={this.handleFiles} fileTypes={'.csv'}>
						<button className="btn">Upload CSV</button>
					</ReactFileReader>
					</div>
					<button
						className="btn btn-secondary"
						style={{marginLeft:'10px'}}
						onClick={this.csvHilfe}
						>CSV Hilfe</button>
				</div>}
				{this.state.fahrerListe && <div>{this.state.fahrerListe.length}</div>}
				{!this.props.auth && <Link to="/login">Einloggen</Link>}
				<div id="space_below" className="w-100 row" style={{backgroundColor: '#fff', height: '220px'}}>
				</div>
			</div>
		);
	}
};

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ submitFahrerBatch }, dispatch)
  }
}

function mapStateToProps({fahrer, auth}) {
	return { fahrer, auth }
}

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);



// WEBPACK FOOTER //
// ./src/components/Dashboard.js